import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';

// mui
import { Grid, Typography, Switch } from '@mui/material';

// lib
import i18n from '../i18n';

// api
import { getSalesPermission } from '../api/getSalesPermission';
import { updateSalesPermission } from '../api/updateSalesPermission';
import { createSalesPermission } from '../api/createSalesPermission';

//interface

// utils
import { generatePayloadObject } from '../utils/util';
var SalesPermissionSection = function SalesPermissionSection(props) {
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    salesInfo = _useState2[0],
    setSalesInfo = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    salesPermissionFlag = _useState4[0],
    setSalesPermissionFlag = _useState4[1];
  var genericPayload = generatePayloadObject(props === null || props === void 0 ? void 0 : props.axiosInstance, props === null || props === void 0 ? void 0 : props.clientToken, '', props === null || props === void 0 ? void 0 : props.role, props === null || props === void 0 ? void 0 : props.requestorPayload, props === null || props === void 0 ? void 0 : props.dcsJwtToken);
  useEffect(function () {
    getSalesPermission(genericPayload).then(function (response) {
      if (response.data) {
        setSalesInfo(response.data);
        setSalesPermissionFlag(response.data.consent);
      } else {
        setSalesInfo({});
      }
    });
  }, []);
  var updateSalesPermissionFlag = function updateSalesPermissionFlag(response) {
    var _response$data;
    if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.consent) {
      setSalesInfo(response.data);
      setSalesPermissionFlag(response.data.consent);
    } else {
      setSalesPermissionFlag(false);
    }
  };
  var handleChange = function handleChange(checked) {
    if (salesInfo && Object.keys(salesInfo).length !== 0) {
      props === null || props === void 0 || props.setLoader(true);
      updateSalesPermission(checked, genericPayload).then(function (updatedSalesResponse) {
        if (updatedSalesResponse.data) {
          getSalesPermission(genericPayload).then(function (salesResponse) {
            props === null || props === void 0 || props.setLoader(false);
            updateSalesPermissionFlag(salesResponse);
          })["catch"](function () {
            props === null || props === void 0 || props.setLoader(false);
          });
        } else {
          props === null || props === void 0 || props.setLoader(false);
        }
      })["catch"](function () {
        props === null || props === void 0 || props.setLoader(false);
      });
    } else {
      props === null || props === void 0 || props.setLoader(true);
      createSalesPermission(genericPayload).then(function (createdSalesResponse) {
        props === null || props === void 0 || props.setLoader(false);
        updateSalesPermissionFlag(createdSalesResponse);
      })["catch"](function () {
        props === null || props === void 0 || props.setLoader(false);
      });
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    component: "h6",
    my: 1,
    sx: {
      marginTop: '18px !important',
      fontWeight: 'bold'
    }
  }, i18n.t('REGISTRATION.PRODUCT_PERMISSION_HEADING')), /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    sx: {
      flex: '0 0 70%'
    }
  }, i18n.t('REGISTRATION.PRODUCT_PERMISSION_DESCRIPTION') + '.'), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    sx: {
      flex: '0 0 20%',
      display: 'flex',
      justifyContent: 'right'
    }
  }, /*#__PURE__*/React.createElement(Switch, {
    checked: salesPermissionFlag,
    onChange: function onChange(event, checked) {
      return handleChange(checked);
    }
  })))));
};
export default SalesPermissionSection;